import React, { FC, ReactNode } from "react";

import { faAngleDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import AntdDropdown, {
  DropDownProps as AntdDropdownProps,
  DropdownButtonProps,
} from "antd/es/dropdown";
import cn from "classnames";

import Button, { ButtonProps } from "../Button";

export const block = bem("mmc-dropdown");

export interface DropdownProps extends AntdDropdownProps {
  buttonProps?: ButtonProps;
  onClick?: DropdownButtonProps["onClick"];
  showArrow?: boolean;
  title?: ReactNode;
}

const Dropdown: FC<DropdownProps> = ({
  buttonProps,
  children,
  className,
  menu,
  onClick,
  showArrow = true,
  title,
  ...props
}) => {
  return (
    <AntdDropdown
      className={cn(block(), className)}
      menu={{ ...menu, className: cn(block("menu"), menu?.className) }}
      {...props}
    >
      {children ?? (
        <Button
          onClick={onClick}
          rightIcon={showArrow ? <FontAwesomeIcon icon={faAngleDown} /> : undefined}
          size="middle"
          type="link"
          {...buttonProps}
        >
          {title}
        </Button>
      )}
    </AntdDropdown>
  );
};

export default Dropdown;
